export const FIND_REF_RESULTS_SUCCESS = 'FIND_REF_RESULTS_SUCCESS';

export const findRefResultsSuccess = ({ results, targetActual }) => ({
    type: FIND_REF_RESULTS_SUCCESS,
    payload: { results, targetActual },
});
